export const DefaultChannelEvents = [
    "initialized",
    "subscribing",
    "subscribed",
    "unsubscribing",
    "unsubscribed",
    "suspended",
    "failed",
    "update",
];
